import dchAPI from '@/services/dchAPI';
import { pickDemoFleet } from '@/services/demo.js';
import config from '@/config';

const state = {
  assets: [],
};

const getters = {
  allAssets: (state) => state.assets.sort((a, b) => a.name.localeCompare(b.name)),
  enabledAssets: (state) => {
    var a = state.assets
      .sort((a, b) => a.name.localeCompare(b.name))
      .filter((asset) => asset.enabled);
    return a;
  },
  platformActiveAssets: (state) => {
    var a = state.assets
      .sort((a, b) => a.name.localeCompare(b.name))
      .filter((asset) => asset.active_in_platform);
    return a;
  },
  assetsBySource: (state) => (source) => {
    return state.assets
      .sort((a, b) => a.name.localeCompare(b.name))
      .filter((asset) => asset.enabled && asset.sources.some((s) => s.handle === source));
  },
  assetsByMultipleSources: (state) => (sourceIds) => {
    // Receives an array of source ids
    return state.assets.filter((asset) =>
      sourceIds.some((source) => asset.sources.some((s) => s.handle === source))
    );
  },
  oneAsset: (state) => (id) => {
    return state.assets.find((asset) => asset.asset_id == id);
  },
  filteredAssets: (state) => (filter) => {
    let a = state.assets;
    if (filter.include_enabled) {
      a = a.filter((asset) => asset.enabled);
    } else if (filter.exclude_enabled) {
      a = a.filter((asset) => !asset.enabled);
    }
    if (filter.include_active) {
      a = a.filter((asset) => asset.active_in_platform);
    } else if (filter.exclude_active) {
      a = a.filter((asset) => !asset.active_in_platform);
    }
    let sorted = a.sort((a, b) => a.name.localeCompare(b.name));
    return sorted;
  },
};

const actions = {
  async fetchAssetsData({ commit }, prefetchedResponse) {
    const response = prefetchedResponse || (await dchAPI.get('assets'));
    const responseData = response.data.data.map((r, index) =>
      transformAssetsResponseData(r, index)
    );
    commit('setAssetsData', responseData);
    return response;
  },
  async fetchAssetsBySource({ commit }, source) {
    return new Promise((resolve, reject) => {
      dchAPI
        .get(`assets?source=${source}`)
        .then((response) => {
          const responseData = response.data.data.map((r, index) =>
            transformAssetsResponseData(r, index)
          );
          commit('setAssetsData', responseData);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async updateInterval(_, { assetId, sourceHandle, originalEnabledAt, enabled_at, disabled_at }) {
    const encodedEnabledAt = encodeURIComponent(originalEnabledAt);
    return new Promise((resolve, reject) => {
      dchAPI
        .patch(
          `assets/${assetId}/sources/${sourceHandle}/intervals?enabled_at=${encodedEnabledAt}`,
          { enabled_at, disabled_at }
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async deleteInterval(_, { assetId, sourceHandle, enabledAt }) {
    const encodedEnabledAt = encodeURIComponent(enabledAt);
    return new Promise((resolve, reject) => {
      dchAPI
        .delete(
          `assets/${assetId}/sources/${sourceHandle}/intervals?enabled_at=${encodedEnabledAt}`
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

const mutations = {
  setAssetsData: (state, assets) => {
    state.assets = config.IS_DEMO === 'true' ? pickDemoFleet(assets) : assets;
  },
};

const transformAssetsResponseData = (data) => {
  let active_in_platform = data.active ?? false;
  return {
    ...{ enabled: true },
    ...data,
    active_in_platform: active_in_platform,
    id: data.asset_id,
    identifier: data.asset_id,
    active: false,
    clicked: false,
    not_connected: false,
    central: false,
    hidden: false,
    show_only_connected_to: false,
    // Demo names are applied by pickDemoFleet once the whole register is known.
    name: data.name.toUpperCase(),
  };
};

export default {
  state,
  getters,
  actions,
  mutations,
};
